var _path, _path2, _path3, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconProfileCollection(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1570_96261)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1570_96261",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H20V20H0V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1570_96261)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1570_96261",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H20V20H0V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1570_96261)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1570_96261",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H20V20H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1570_96261)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9667 1.99415C14.9775 1.99397 15.9657 2.29361 16.8062 2.85514C17.6467 3.41668 18.3018 4.21488 18.6886 5.14879C19.0754 6.08269 19.1765 7.11034 18.9792 8.10173C18.7819 9.09312 18.2949 10.0037 17.58 10.7183L10.4967 17.8016C10.4317 17.8667 10.3545 17.9182 10.2696 17.9534C10.1846 17.9886 10.0936 18.0067 10.0017 18.0067C9.90973 18.0067 9.8187 17.9886 9.73376 17.9534C9.64883 17.9182 9.57166 17.8667 9.50666 17.8016L2.42333 10.7183C1.46501 9.76 0.926636 8.46024 0.926636 7.10498C0.926636 5.74972 1.46501 4.44996 2.42333 3.49165C3.38164 2.53333 4.6814 1.99495 6.03666 1.99495C7.39192 1.99495 8.69168 2.53333 9.64999 3.49165L10.005 3.84665L10.36 3.49165C10.8325 3.01627 11.3945 2.63918 12.0135 2.38216C12.6326 2.12513 13.2964 1.99326 13.9667 1.99415Z",
    fill: "#9196AF"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1570_96261"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProfileCollection);
export default __webpack_public_path__ + "static/media/icon-profile-collection.82b0948e708b7cd0245ac665b2837226.svg";
export { ForwardRef as ReactComponent };